import z from "zod";

import { ApiResp, ApiRespSchema } from "./response";

export const PageReqSchema = z.object({
  page: z.coerce.number().min(0).default(0),
  limit: z.coerce.number().min(1).default(10)
});
export type PageReq = z.infer<typeof PageReqSchema>;

export const PageMetaSchema = z.object({
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number(),
  hasNext: z.boolean(),
  hasPrev: z.boolean()
});
export type PageMeta = z.infer<typeof PageMetaSchema>;

export const PageDataSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({ data: z.array(dataSchema), meta: PageMetaSchema });
export type PageData<T> = {
  data: T[];
  meta: PageMeta;
};

export const PageRespSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  ApiRespSchema(PageDataSchema(dataSchema));
export type PageResp<T> = ApiResp<PageData<T>>;
